import { Heading, useToast } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginConfirm } from '../../Services/AuthService';
import axiosInstance from '../../Services/axiosInstance';
import axios from 'axios';

export default function SSOLogin() {
  const [loading, setLoading] = useState(true);
  const toast = useToast();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Helper to fetch user data using the JWT from backend
  const fetchUserData = async (jwtToken, orgToken) => {
    try {
      // Parse the orgToken string to extract the token
      // const parsedOrgToken = JSON.parse(orgToken);
      // const orgTokenValue = parsedOrgToken?.token;
      
      

      // Build the query parameters
      const queryParams = new URLSearchParams();
      if (orgToken) {
        queryParams.append('orgToken', orgToken);
      }

      // Make the API call with the token as query parameter
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT}/jwt/userdata?${queryParams.toString()}`
        ,
        {
          headers:{
            'token':jwtToken
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error('Failed to fetch user data:', error);
      throw new Error('Failed to fetch user profile');
    }
  };

  useEffect(() => {
    const processSSOLogin = async () => {
      const queryParams = new URLSearchParams(window.location.search);
      const encodedToken = queryParams.get('token');
      let orgToken = null
      try{
        orgToken = JSON.parse(queryParams.get('org') || '{}')?.token;
      }catch(e){
           orgToken = (queryParams.get('org') || '');
      }
      const isSuperAdminParam = queryParams.get('isSuperAdmin') === 'true';

      if (!encodedToken) {
        toast({
          title: 'Missing SSO token',
          description: 'No authentication token found.',
          status: 'error',
          duration: 5000,
        });
        navigate('/login');
        return;
      }

      try {
        setLoading(true);

        // Step 1: Fetch actual user data from backend using the JWT
        const userData = await fetchUserData(encodedToken, orgToken);

        // Step 2: Prepare data for loginConfirm
        const loginData = {
          jwt: encodedToken,
          userData: userData, // Real user object, not a function
          orgToken: orgToken || null,
          isSuperAdmin: isSuperAdminParam || userData?.isSuperAdmin ,
        };

        console.log('SSO Login Data:', loginData);

        // Step 3: Trigger login confirmation with full user data
        await loginConfirm(undefined, undefined, loginData, dispatch, navigate);

      } catch (error) {
        console.error('SSO Login failed:', error);
        toast({
          title: 'SSO Login Failed',
          description: error.message || 'Invalid or expired token.',
          status: 'error',
          duration: 8000,
        });
        navigate('/login');
      } finally {
        setLoading(false);
      }
    };

    processSSOLogin();
  }, [toast, navigate, dispatch]);

  if (loading) {
    return <Heading textAlign="center">Authenticating...</Heading>;
  }

  return <Heading textAlign="center">Redirecting...</Heading>;
}